import { Organizer, IOrganizer }     from '../Organizer/Organizer';
import { EventTicket, IEventTicket } from '../EventTicket/EventTicket';
import { Invoice, IInvoice }         from '../Invoice/Invoice';
import User, { IUser }               from '../User/User';
import { createUniqKey }             from 'Utils';
import { Event, IEvent }             from '../Event/Event';

export interface IUserTicket {
  id: string,
  createdAt: number,
  activatedAt: number,
  eventId: string,
  eventTicketId: string,
  organisationId: string,
  userId: string,
  invoiceId: string,
  basketId: string,
  status: string,
  promo: boolean,
  ticketNumber: string,
  qrCodeString: string,
  calcTicketPercentageFee: string,
  netto: number,
  price: number,
  organisation: IOrganizer,
  event: IEvent,
  eventTicket: IEventTicket,
  user: IUser,
  invoice: IInvoice,
  currentOwner: IUser | null,
  currentOwnerId: string | null,
}

export class UserTicket {
  public _key: string;
  public id: string;
  public createdAt: Date | null;
  public activatedAt: Date | null;
  public eventId: string;
  public eventTicketId: string;
  public organisationId: string;
  public userId: string;
  public currentOwnerId: string | null;
  public invoiceId: string;
  public basketId: string;
  public status: string;
  public ticketNumber: string;
  public qrCodeString: string;
  public calcTicketPercentageFee: string;
  public netto: number;
  public price: number;
  public promo: boolean;

  public organisation: Organizer | null;
  public event: Event | null;
  public eventTicket: EventTicket | null;
  public user: User | null;
  public currentOwner: User | null;
  public invoice: Invoice | null;

  constructor(data: IUserTicket) {
    this._key = createUniqKey();
    this.id = data.id;

    this.createdAt = data.createdAt ? new Date(data.createdAt * 1000) : null;
    this.activatedAt = data.activatedAt ? new Date(data.activatedAt * 1000) : null;
    this.eventId = data.eventId;
    this.eventTicketId = data.eventTicketId;
    this.organisationId = data.organisationId;
    this.userId = data.userId;
    this.currentOwnerId = data.currentOwnerId;
    this.invoiceId = data.invoiceId;
    this.basketId = data.basketId;
    this.status = data.status;
    this.promo = data.promo;
    this.ticketNumber = data.ticketNumber;
    this.qrCodeString = data.qrCodeString;
    this.calcTicketPercentageFee = data.calcTicketPercentageFee;
    this.netto = data.netto;
    this.price = data.price;
    this.organisation = data.organisation ? new Organizer(data.organisation) : null;
    this.event = data.event ? new Event(data.event) : null;
    this.eventTicket = data.eventTicket ? new EventTicket(data.eventTicket) : null;
    this.user = data.user ? new User(data.user) : null;
    this.currentOwner = data.currentOwner ? new User(data.currentOwner) : null;
    this.invoice = data.invoice ? new Invoice(data.invoice) : null;

  }
}
